import React, { useState, useEffect, useRef } from 'react';

function CariBank({ onSelect, onCancel }) {
  const [rekeningList, setRekeningList] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredRekening, setFilteredRekening] = useState([]);
  const schema = localStorage.getItem('schema');
  const inputRef = useRef(null); // 🔹 referensi untuk input pencarian

  useEffect(() => {
    // 🔹 Auto-focus ke input saat form dibuka
    if (inputRef.current) {
      inputRef.current.focus();
    }

    const fetchRekening = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=bank&schema=${schema}`
        );
        const data = await response.json();
        const rekeningArray = Array.isArray(data) ? data : [];
        setRekeningList(rekeningArray);
        setFilteredRekening(rekeningArray);
      } catch (error) {
        console.error('Error fetching rekening:', error);
      }
    };
    fetchRekening();
  }, [schema]);

  useEffect(() => {
    if (!Array.isArray(rekeningList)) return;
    const filtered = rekeningList.filter(
      (rekening) =>
        rekening.NAMAREKENING?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        rekening.KD_REK_GL?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredRekening(filtered);
  }, [searchTerm, rekeningList]);

  const isMobile = window.innerWidth <= 480;

  return (
    <div
      style={{
        width: isMobile ? '90%' : '420px',
        margin: isMobile ? '20px auto' : '40px auto',
        padding: isMobile ? '15px' : '20px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        backgroundColor: '#ffffff',
        boxShadow: '0 3px 6px rgba(0,0,0,0.1)',
        position: 'relative',
      }}
    >
      <button
        onClick={onCancel}
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          backgroundColor: '#f44336',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          padding: isMobile ? '4px 8px' : '6px 12px',
          cursor: 'pointer',
          fontSize: isMobile ? '12px' : '14px',
        }}
      >
        ✖
      </button>

      <h2
        style={{
          textAlign: 'center',
          color: '#333',
          marginTop: isMobile ? '10px' : '0',
          marginBottom: '15px',
          fontSize: isMobile ? '16px' : '20px',
        }}
      >
        Cari Bank
      </h2>

      <div style={{ marginBottom: '15px' }}>
        <input
          ref={inputRef} 
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Masukkan kode atau nama rekening..."
          style={{
            width: '100%',
            padding: isMobile ? '6px' : '8px',
            borderRadius: '6px',
            border: '1px solid #ccc',
            fontSize: isMobile ? '13px' : '14px',
          }}
        />
      </div>

      <div
        style={{
          maxHeight: isMobile ? '240px' : '300px',
          overflowY: 'auto',
          overflowX: 'hidden',
          borderRadius: '6px',
          border: '1px solid #eee',
        }}
      >
        <table
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: isMobile ? '12.5px' : '14px',
          }}
        >
          <thead>
            <tr style={{ backgroundColor: '#f0f0f0' }}>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: isMobile ? '6px' : '8px',
                  width: isMobile ? '30%' : '25%',
                }}
              >
                Kode
              </th>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: isMobile ? '6px' : '8px',
                  width: isMobile ? '45%' : '55%',
                }}
              >
                Rekening
              </th>
              <th
                style={{
                  border: '1px solid #ddd',
                  padding: isMobile ? '6px' : '8px',
                  textAlign: 'center',
                  width: isMobile ? '25%' : '20%',
                }}
              >
                Aksi
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredRekening.length > 0 ? (
              filteredRekening.map((rekening, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9',
                    cursor: 'pointer',
                  }}
                  onDoubleClick={() => onSelect(rekening)}  
                >
                  <td
                    style={{
                      border: '1px solid #ddd',
                      padding: isMobile ? '5px' : '6px',
                      wordWrap: 'break-word',
                    }}
                  >
                    {rekening.KD_REK_GL}
                  </td>
                  <td
                    style={{
                      border: '1px solid #ddd',
                      padding: isMobile ? '5px' : '6px',
                      wordWrap: 'break-word',
                    }}
                  >
                    {rekening.NAMAREKENING}
                  </td>
                  <td
                    style={{
                      textAlign: 'center',
                      border: '1px solid #ddd',
                      padding: isMobile ? '4px' : '6px',
                    }}
                  >
                    <button
                      onClick={() => onSelect(rekening)}
                      style={{
                        padding: isMobile ? '3px 6px' : '4px 10px',
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        fontSize: isMobile ? '12px' : '13px',
                      }}
                    >
                      Pilih
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="3"
                  style={{
                    textAlign: 'center',
                    padding: '10px',
                    color: '#888',
                    fontSize: isMobile ? '13px' : '14px',
                  }}
                >
                  Tidak ada data rekening.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default CariBank;
